import { render, staticRenderFns } from "./my-nominees-component.vue?vue&type=template&id=e3fe7218&scoped=true"
import script from "./my-nominees-component.ts?vue&type=script&lang=ts&external"
export * from "./my-nominees-component.ts?vue&type=script&lang=ts&external"
import style0 from "./my-nominees-component.scss?vue&type=style&index=0&id=e3fe7218&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fe7218",
  null
  
)

export default component.exports